import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Navbar, Nav } from "react-bootstrap";
import { FaBars, FaTimes } from "react-icons/fa";
import "./MyNavbar.css";
import logo from "./Michael.png";

const MyNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [isScrolled, setIsScrolled] = useState(false);

  let docTitle = document.title;
  window.addEventListener("blur", () => {
    document.title = "Come back 😉";
  });

  window.addEventListener("focus", () => {
    document.title = docTitle;
  });

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuClick = (menu) => {
    setSelectedMenu(menu);
    setIsOpen(false);
  };

  const navItems = [
    { label: "Root", path: "/" },
    { label: "About Me", path: "/about-me" },
    { label: "Projects", path: "/projects" },
    { label: "Packages", path: "/proficiency" },
    { label: "Reach Out", path: "/contacts" },
  ];

  return (
    <>
      <Navbar
        className={`my-navbar position-fixed d-flex w-100 p-3 mb-4 sticky-top  ${
          isScrolled ? "bg-white" : " "
        }`}
        expand="md"
      >
        <div className="d-flex w-100 justify-content-between container">
          <Link className="navbar-brand mx-2" to="/">
            <img width={"100"} src={logo} alt="me" />
          </Link>
          <button
            className="navbar-toggler  mx-3"
            type="button"
            onClick={toggleMenu}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
          <Nav
            className="mr-auto desktop-menu justify-content-end w-100"
            navbar
          >
            {navItems.map((item) => (
              <Nav.Link
                key={item.path}
                as={Link}
                to={item.path}
                className={`nav-link ${
                  selectedMenu === item.label ? "active" : ""
                }`}
                onClick={() => handleMenuClick(item.label)}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </div>
        <div
          className={`mobile-menu-overlay ${isOpen ? "show" : ""}`}
          onClick={toggleMenu}
        />
        <div className={`mobile-menu ${isOpen ? "show" : ""}`}>
          <div className="mobile-menu-header">
            <span className="selected-menu">
              {selectedMenu ? selectedMenu.toUpperCase() : ""}
            </span>
          </div>

          <Nav className="flex-column mobile-nav">
            {navItems.map((item) => (
              <Nav.Link
                key={item.path}
                as={Link}
                to={item.path}
                className={`nav-link ${
                  selectedMenu === item.label ? "active" : ""
                }`}
                onClick={() => handleMenuClick(item.label)}
              >
                {item.label}
              </Nav.Link>
            ))}
          </Nav>
        </div>
      </Navbar>
      <div className="breadcrumb-container container fw-bolder">
        <div className="container">
          <ol className="breadcrumb d-flex justify-content-end align-items-center">
            {selectedMenu ? (
              <>
                <li className="breadcrumb-item">
                  <Link to="/">My Portfolio</Link>
                </li>
                <li className="breadcrumb-item active">
                  <Link to={{ selectedMenu }}>{selectedMenu}</Link>
                </li>
              </>
            ) : (
              <li className="breadcrumb-item active">My Portfolio</li>
            )}
          </ol>
        </div>
      </div>
    </>
  );
};

export default MyNavbar;
